import { render, staticRenderFns } from "./KrepostEvent.vue?vue&type=template&id=47aecc60&scoped=true"
import script from "./KrepostEvent.vue?vue&type=script&lang=js"
export * from "./KrepostEvent.vue?vue&type=script&lang=js"
import style0 from "./KrepostEvent.vue?vue&type=style&index=0&id=47aecc60&prod&lang=scss&scoped=true"
import style1 from "./KrepostEvent.vue?vue&type=style&index=1&id=47aecc60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aecc60",
  null
  
)

export default component.exports